import $, { parseJSON } from 'jquery';

// import 'popper.js';
import 'bootstrap/js/dist/alert';
// import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';
import 'bootstrap/js/dist/tooltip';

if (!window.HTMLPictureElement) {
    import('picturefill');
}


let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};
window.app.modules = app.modules || {};

import initModulesInScope from "./libs/@elements/init-modules-in-scope";
app.initModules = function ($scope) {
    console.warn('\'app.initModules\' is going to be deprecated and should not be used anymore. Please import and use \'initModulesInScope\' from \'./scripts/initModulesInScope\' instead.');
    initModulesInScope($scope);
};

$.loadScript = function (url) {
    console.warn('\'$.loadScript\' is going to be deprecated and should not be used anymore. Please use \'import\' for local files or import and use \'loadScript\' for external resources.');

    return import('./libs/@elements/load-script').then(function (loadScript) {
        return loadScript.default(url);
    });
};

/**********************************
 *
 *      Project Stuff
 *
 * ********************************/
import * as Macy from 'macy';

import * as ajaxInclude from './scripts/ajaxInclude';
app.modules.ajaxInclude = ajaxInclude.initInScope;

import * as goToLink from './libs/@elements/go-to-link';
app.goToLink = goToLink.init;

import * as videoJs from './scripts/videoJs';
app.modules.videoJs = videoJs.initInScope;

import * as toc from './libs/@elements/toc';
app.toc = toc.init;
app.modules.toc = toc.initInScope;

import * as lazyImg from './libs/@elements/lazy-img';
app.modules.lazyImg = lazyImg.initInScope;

import * as shariff from './scripts/shariff';
app.modules.shariff = shariff.initInScope;

import * as productGridFilter from './scripts/productGridFilter';
app.modules.productGridFilter = productGridFilter.initInScope;

import * as lightbox from './libs/@elements/lightbox';
app.modules.lightbox = lightbox.createInitInScope({
    base: '.js-lightbox',
    item: '.js-lightbox__item'
}, {
    hideBarsDelay: 99999999,
    subHtmlSelectorRelative: true
});

import * as datepicker from './libs/@elements/datepicker';
// app.modules.datepicker = datepicker.initInScope;
app.modules.datepicker = datepicker.createInitInScope({
    base: '.js-datepicker',
    input: '.js-datepicker__input',
    altField: '.js-datepicker__alt-field'
}, {
    /*options*/
    numberOfMonths: 1,
    nextText: '<span class="icon icon-arrow-left"></span>',
    prevText: '<span class="icon icon-arrow-left"></span>',
});

import * as floatingLabel from './libs/@elements/floating-labels';
app.modules.floatingLabel = floatingLabel.initInScope;

import * as pdsVideo from './scripts/pds-video';
app.modules.pdsVideo = pdsVideo.initInScope;

import * as header from './scripts/header';
app.header = header.init;

import * as parsley from './libs/@elements/parsley-bootstrap-validation';
app.modules.parsley = parsley.initInScope;

import * as navbarToggle from './scripts/navbar-toggle';
app.modules.navbarToggle = navbarToggle.initInScope;

import * as matchMediaViewer from "./scripts/matchmedia-viewer";
app.matchMediaViewer = matchMediaViewer.init;
app.modules.matchMediaViewer = matchMediaViewer.initInScope;

import * as keepOpenDropdown from './scripts/keep-open-dropdown';
app.modules.keepOpenDropdown = keepOpenDropdown.initInScope;

import * as formAutoSubmit from './scripts/form-auto-submit';
app.modules.formAutoSubmit = formAutoSubmit.initInScope;

import * as overlayToggle from './scripts/overlay-toggle';
app.modules.overlayToggle = overlayToggle.initInScope;

import * as productLightbox from './scripts/product-lightbox';
app.modules.productLightbox = productLightbox.initInScope;

import * as touchNav from './scripts/touch-nav';
app.modules.touchNav = touchNav.initInScope;

import * as navAccesibility from './libs/@elements/accessibility-nav';
app.modules.accessibilityNav = navAccesibility.initInScope;

import * as productTeaserMainSlider from './scripts/product-teaser-main-slider';
app.modules.productTeaserMainSlider = productTeaserMainSlider.initInScope;

import * as productGrid from './libs/@elements/product-grid';
app.productGrid = productGrid.init;
app.modules.productGrid = productGrid.initInScope;

import * as productGridQuickFilter from './libs/@elements/product-grid/quick-filter';
app.modules.productGridQuickFilter = productGridQuickFilter.initInScope;

import * as submitForm from './scripts/submitForm';
app.modules.submitForm = submitForm.initInScope;

import * as cartOverview from './scripts/cartOverview';
app.modules.cartOverview = cartOverview.initInScope;

import * as cart from './scripts/cart';
app.cart = cart.init;
app.modules.cart = cart.initInScope;

import * as teaserSlider from './scripts/teaser-slider';
app.modules.teaserSlider = teaserSlider.initInScope;

import * as heroTeaserSlider from './scripts/hero-teaser-slider';
app.modules.heroTeaserSlider = heroTeaserSlider.initInScope;

import * as wysiwygSlider from './scripts/wysiwyg-slider';
app.modules.wysiwygSlider = wysiwygSlider.initInScope;

import * as addCart from './scripts/addCart';
app.addCart = addCart.init;
app.modules.addCart = addCart.initInScope;

import * as cartDetail from './scripts/cartDetail';
app.modules.cartDetail = cartDetail.initInScope;

import * as discount from './scripts/discount';
app.modules.discount = discount.initInScope;

import * as ImgTeaserSlider from './scripts/img-teaser-slider';
app.modules.ImgTeaserSlider = ImgTeaserSlider.initInScope;

import * as CustomImgSlider from './scripts/custom-img-slider';
app.modules.CustomImgSlider = CustomImgSlider.initInScope;

import * as gallerySlider from './scripts/gallery-slider';
app.modules.gallerySlider = gallerySlider.initInScope;

import * as multipleFileDownload from './scripts/multiple-file-download';
app.modules.multipleFileDownload = multipleFileDownload.initInScope;

import * as affix from './libs/@elements/affix';
app.modules.affix = affix.createInitInScope({
    mediaQuery: '(min-width: 768px)'
});

import * as ejb from './libs/@elements/elements-job-bundle';
app.modules.ejbAjaxForm = ejb.ajaxForm.initInScope;
app.modules.ejbDateInput = ejb.dateInput.initInScope;
app.modules.ejbGallery = ejb.gallery.initInScope;

import * as smoothScroll from './libs/@elements/smooth-scroll';
app.smoothScroll = smoothScroll.init;
app.modules.smoothScroll = smoothScroll.initInScope;

import * as anchorTabs from './scripts/anchor-tabs';
app.modules.anchorTabs = anchorTabs.initInScope;

import * as storeSearch from './scripts/storeSearch';
app.modules.storeSearch = storeSearch.initInScope;

import * as checkout from './scripts/checkout';
app.modules.checkout = checkout.initInScope;

import * as scrollTop from './scripts/scrollTop';
app.modules.scrollTop = scrollTop.initInScope;

import * as wishlist from './scripts/wishlist';
app.wishlist = wishlist.init;
app.modules.wishlist = wishlist.initInScope;

import * as scrollTo from './scripts/scroll-to';
app.modules.scrollTo = scrollTo.initInScope;

import * as centerActiveTab from './scripts/center-active-tab';
app.modules.centerActiveTab = centerActiveTab.initInScope;

import * as checkAvailability from './scripts/check-availability';
app.modules.checkAvailability = checkAvailability.initInScope;

import * as toggleClick from './scripts/toggle-click';
app.modules.toggleClick = toggleClick.initInScope;

import * as tooltip from './scripts/tooltip';
app.modules.tooltip = tooltip.initInScope;

import * as repeater from './scripts/repeater';
app.modules.repeater = repeater.initInScope;

import * as ajaxLoad from './scripts/ajaxLoad';
app.modules.ajaxLoad = ajaxLoad.initInScope;

import * as requestCart from "./scripts/requestCart";
app.modules.requestCart = requestCart.initInScope;

import * as waitForPayment from "./scripts/waitForPayment";
app.modules.waitForPayment = waitForPayment.initInScope;

// import * as targeting from "./scripts/targeting";
// app.targeting = targeting.initInScope;


import * as popover from './scripts/popover';
app.modules.popover = popover.initInScope;

import * as copyToClipboard from './scripts/copyToClipboard';
app.modules.copyToClipboard = copyToClipboard.initInScope;

import * as cutoutSlider from './scripts/cutout-slider';
app.modules.cutoutSlider = cutoutSlider.initInScope;

import * as tracking from "./libs/@elements/tracking";
tracking.initGtmEventTracking();

import * as slider from './libs/@elements/slider';
app.modules.productDetailSlider = slider.createInitInScope('.js-product-detail-slider', {
    nextArrow: '<button type="button" class="slick-next slider__arrow-styled" aria-label="Next"><span class="slider__arrow__icon icon icon-arrow-long-right"></span></button>',
    prevArrow: '<button type="button" class="slick-prev slider__arrow-styled" aria-label="Previous"><span class="slider__arrow__icon icon icon-arrow-long-left"></span></button>',
    infinite: false,
    slidesToShow: 1.3,
    slidesToScroll: 1
});

import * as circleImgTeaserSlider from './scripts/circle-img-teaser-slider';
app.modules.circleImgTeaserSlider = circleImgTeaserSlider.initInScope;

app.modules.simpleImgSlider = slider.createInitInScope('.js-simple-img-slider', {
    nextArrow: '<button type="button" class="slick-next slider__arrow-styled" aria-label="Next"><span class="slider__arrow__icon icon icon-arrow-long-right"></span></button>',
    prevArrow: '<button type="button" class="slick-prev slider__arrow-styled" aria-label="Previous"><span class="slider__arrow__icon icon icon-arrow-long-left"></span></button>',
    infinite: false,
    slidesToShow: 1.3,
    slidesToScroll: 1
});


app.modules.storeSlider = slider.createInitInScope('.js-store-slider', {
    nextArrow: '<button type="button" class="slick-next slider__arrow-styled" aria-label="Next"><span class="slider__arrow__icon icon icon-arrow-long-right"></span></button>',
    prevArrow: '<button type="button" class="slick-prev slider__arrow-styled" aria-label="Previous"><span class="slider__arrow__icon icon icon-arrow-long-left"></span></button>',
    infinite: true,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1
});


import * as ajaxForm from './libs/@elements/ajax-form';
app.modules.ajaxForm = ajaxForm.createInitInScope({
    addUrlParams: true
});

import * as ajaxFormScroll from './scripts/ajax-form-scroll';
app.modules.ajaxFormScroll = ajaxFormScroll.initInScope;

import * as hotspots from './scripts/hotspots';
app.hotspots = hotspots.init;
app.modules.hotspots = hotspots.initInScope;

import * as reCaptchaV3 from './scripts/reCaptchaV3';
app.modules.reCaptchaV3 = reCaptchaV3.initInScope;

// import { showCookieBar } from "./libs/@elements/cookie-permissions";
// if (!_config.admin && !_config.editmode && _config.showCookieBar) {
//     showCookieBar();
// }

import { translate } from "./libs/@elements/translations";


import * as typeahead from './libs/@elements/typeahead';
let typeaheadOptions = {
    autocompleteText: 'title'
};

const layouts = {
    headerLayout: (data, category) => {
        return ('<div class="typeahead-heading d-flex justify-content-between">' +
            '<a href="' + data.overviewUrl + '" class="typeahead-heading__text mb0">' +
            '<span class="typeahead-heading__icon text-primary ' + category.icon + '"></span><span>' + category.title + '</span></a>' +
            '<a href="' + data.overviewUrl + '" class="typeahead-heading__link mb0">' +
            '<span class="">' + translate('typeahead.showmore') + '</span></a>' +
            '</div>')
    },
    suggestionLayout: (data) => {
        return (
            '<div class="typeahead-suggestion">' + data.title + '<div class="typeahead-suggestion__text">' + data.text + '</div></div>')
    },
    errorLayout: () => {
        return ''
    }
};

app.modules.typeahead = typeahead.createInitInScope(typeaheadOptions, layouts);

import * as fileInput from './libs/@elements/file-input';
app.modules.fileInput = fileInput.initInScope;

import * as quickOrder from './scripts/quick-order';
app.modules.quickOrder = quickOrder.initInScope;

import * as langLinks from './scripts/lang-links';
app.modules.langLinks = langLinks.initInScope;

import * as variantSelect from './scripts/variant-select';
app.modules.variantSelect = variantSelect.initInScope;

import * as filterSearch from './scripts/filter-search';
app.modules.filterSearch = filterSearch.initInScope;

import * as perPage from './scripts/per-page';
app.modules.perPage = perPage.initInScope;

import * as createCart from './scripts/create-cart';
app.modules.createCart = createCart.initInScope;

if (matchMedia('(max-width: 767px)').matches) {
    let $slider = $('.js-tab-slider-xs');
    app.modules.tabSliderXs = slider.createInitInScope($slider, {
        nextArrow: '<button type="button" class="btn-no-styling slick-next slider__arrow" aria-label="Next"><span class="slider__arrow__icon icon icon-arrow-down"></span></button>',
        prevArrow: '<button type="button" class="btn-no-styling slick-prev slider__arrow" aria-label="Previous"><span class="slider__arrow__icon icon icon-arrow-down"></span></button>',
        infinite: false,
        dots: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        variableWidth: true
    });

    $slider.find('a[data-toggle="tab"]').on("show.bs.tab", function (evt) {
        $slider.find('a[data-toggle="tab"]').filter((index, item) => {
            if (item !== evt.target) {
                $(item).removeClass('active');
                $(item.getAttribute('href')).removeClass('show')
            }
        });
    });
}

import * as consoleJs from './scripts/console';
app.modules.console = consoleJs.initInScope;

import * as steps from './scripts/steps';
app.modules.steps = steps.initInScope;

import * as fadeIn from './scripts/fade-in';
app.modules.fadeIn = fadeIn.initInScope;

app.modules.quoteSlider = slider.createInitInScope('.js-quote-slider', {
    nextArrow: '<button type="button" class="slick-next slider__arrow-styled" aria-label="Next"><span class="slider__arrow__icon icon icon-arrow-long-right"></span></button>',
    prevArrow: '<button type="button" class="slick-prev slider__arrow-styled" aria-label="Previous"><span class="slider__arrow__icon icon icon-arrow-long-left"></span></button>',
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1
});

app.modules.mediaBoxSlider = slider.createInitInScope('.js-media-box-slider', {
    nextArrow: '<button type="button" class="slick-next slider__arrow-styled" aria-label="Next"><span class="slider__arrow__icon icon icon-arrow-long-right"></span></button>',
    prevArrow: '<button type="button" class="slick-prev slider__arrow-styled" aria-label="Previous"><span class="slider__arrow__icon icon icon-arrow-long-left"></span></button>',
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1
});

import * as viewportVideo from './scripts/viewport-video';
app.modules.viewportVideo = viewportVideo.initInScope;


import * as imageCompare from './scripts/image-compare';
app.modules.imageCompare = imageCompare.initInScope;

// Place this near the top, after other function declarations
function fetchBulkPrices() {
    const $priceElements = $('.js-external-price[data-item-number]');
    if (!$priceElements.length) return;

    // Collect all item numbers
    const itemNumbers = $priceElements.map(function () {
        return $(this).data('item-number');
    }).get();

    // Show loading for all
    $priceElements.each(function () {
        $(this).html('<span class="external-price-loading">&hellip;</span>');
    });

    $.ajax({
        url: '/api/product/price-range-bulk',
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ itemNumbers }),
        success: function (data) {
            if (!data.success || !data.data) throw new Error('No price data');
            const prices = data.data;
            $priceElements.each(function () {
                const $el = $(this);
                const itemNumber = $el.data('item-number');
                const priceData = prices[itemNumber];
                if (!priceData) {
                    $el.html('');
                    return;
                }
                let html = '';
                if (priceData.price_range) {
                    html += formatPrice(priceData.price_min, priceData.currency);
                    html += ' - ';
                    html += formatPrice(priceData.price_max, priceData.currency);
                } else {
                    html += formatPrice(priceData.net_price, priceData.currency);
                    // html += '<div class="brutto-price">' + formatPrice(priceData.price, priceData.currency) + ' incl. VAT</div>';
                }
                $el.html(html);
            });
        },
        error: function () {
            $priceElements.each(function () {
                $(this).html('');
            });
        }
    });
}
window.fetchBulkPrices = fetchBulkPrices;

function formatPrice(amount, currency) {
    let formatted = Number(amount).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    switch (currency) {
        case 'CHF':
            return formatted + ' CHF.';
        case 'GBP':
            return '£' + formatted;
        case 'SEK':
        case 'NOK':
        case 'DKK':
            return formatted + ' kr';
        case '€':
        case 'EUR':
            return formatted + ' €';
        default:
            return formatted + ' ' + currency;
    }
}
window.formatPrice = formatPrice;

(function ($) {
    "use strict";

    /* -> _config._preload = Load this functions first */
    if (_config['_preload']) {
        $.each(_config['_preload'], function (_key, _val) {
            if (typeof _val == 'boolean' && typeof window.app[_key] == 'function') {
                window.app[_key]();
            }
        });
    }

    /* -> _config = Load all others (not _preload and _reload) */
    $.each(_config, function (_key, _val) {
        if ((typeof _val == 'boolean' && typeof window.app[_key] == 'function' && _key != '_reload' && _key != '_preload')) {
            window.app[_key]();
        }
    });

    /* -> _config._reload = Load the ajaxInclued and others after the rest */
    if (_config['_reload']) {
        $.each(_config['_reload'], function (_key, _val) {
            if ((typeof _val == 'boolean' && typeof window.app[_key] == 'function')) {
                window.app[_key]();
            }
        });
    }
    $("body").on("click", ".js-open-extended-dialog", function() {
        $("#extended-dialog").css('display', 'block');
        if($(this).data('multi')){
            $(".extended-multi-js").removeClass('d-none');
            $(".extended-single-js").addClass('d-none');
        }
        else {
            $(".extended-single-js").removeClass('d-none');
            $(".extended-multi-js").addClass('d-none');
        }
        setTimeout(function() {
            $("#extended-dialog").addClass('show');
            $("body").addClass("modal-open");
        }, 200);
    });

    $("body").on("click", ".js-close-extended-dialog", function() {
        $("#extended-dialog").removeClass('show');
        setTimeout(function() {
            $("#extended-dialog").css('display', 'none');
            $("body").removeClass("modal-open");
        }, 200);
    });

    $("body").on("click", ".rating-item", function () {
        $(".rating-active").removeClass("rating-active");
        $(this).addClass('rating-active');
        $(this).parent().parent().find('input').val($(this).find('.rating-number').text().trim());
    })
    function addAndRecalculateHotspots() {
        var images = $(".project-gallery-grid__img-wrapper");
        var hotspots = $(".hotspot");
        var $template = $(".hotspot__template");
        if ($template.length) {
            $template = $template[0].innerHTML;

            for (let i = hotspots.length; i < images.length / 8; i++) {
                var offset = 0;
                if (i % 2 === 0) {
                    offset = 0;
                } else {
                    offset = 3;
                }
                $(images[i * 8 + offset]).append($template);
            }
            hotspots = $(".hotspot");
            for (let i = 0; i < hotspots.length; i++) {
                if (i % 2 === 0) {
                    $(hotspots[i]).css('left', '-50px');
                } else {
                    $(hotspots[i]).css('float', 'right');
                    $(hotspots[i]).css('right', '-50px');
                    $(hotspots[i]).css('left', 'auto');
                }
                if (i % 4 === 0) {
                    $(hotspots[i]).css('height', '600px');
                } else if (i % 4 === 1) {
                    $(hotspots[i]).css('height', '300px');
                } else if (i % 4 === 2) {
                    $(hotspots[i]).css('height', '300px');
                } else if (i % 4 === 3) {
                    $(hotspots[i]).css('height', '600px');
                }
            }
        }
    }

    function getUrlFromInput(keyword) {
        var url = "";
        $(".js-product-grid__input:checked").each(function () {
            if (keyword === undefined || $(this)[0].value.toLowerCase() !== keyword) {
                if (url === "") {
                    url = location.href.split("?")[0] + "?";
                } else {
                    url += "&"
                }
                url += $(this)[0].name + "[]=" + $(this)[0].value;
            }
        })
        if (url === "") {
            url = location.href.split("?")[0];
        }
        return url
    }
    if ($(".project-gallery-grid__gallery-wrapper").length) {
        var macy = Macy({
            container: '.project-gallery-grid__gallery-wrapper',
            trueOrder: false,
            waitForImages: false,
            margin: 12,
            columns: 4,
            breakAt: {
                1200: 4,
                940: 3,
                520: 2,
                400: 1
            }
        });
        macy.runOnImageLoad(function () {
            macy.recalculate(true, true);
            $(".project-gallery-grid__img-overlay").removeClass("not-loaded-yet");
        });
        addAndRecalculateHotspots();
    }
    const $body = $("body");
    $body.on("submit", ".js-request-loxone__form", function (e) {
        e.preventDefault();
        let data = $(".js-request-loxone__form").serialize();
        $.ajax({
            url: '/request-loxone', 
            method: 'POST', 
            data: data, 
            success: (data) => {
                $(".modal-body__close").click();
                $(".js-request-loxone__form")[0].reset();

            }, error: (data) => { }
        })
    });
    $body.on("click", ".project-gallery-grid__apply-filter--js", function () {
        $(".js-product-grid__loading")[0].hidden = false;
        const url = getUrlFromInput();

        history.pushState({
            'productGridAjaxUrl': url,
            'productGridInputState': [],
            'productGridAdditionalInputState': []
        },
            document.title,
            url
        );
        $.ajax({
            url: url,
            dataType: "json",
            success: (data) => {
                $(".js-product-grid__loading")[0].hidden = true;
                $(".pagenumber")[0].innerText = 0;
                const filterBar = $(".filter-bar__container")
                filterBar.empty();
                filterBar.append(data.filter);
                const galleryWrapper = $(".project-gallery-grid__gallery-wrapper")
                galleryWrapper.empty();
                galleryWrapper.append(data.html);
                macy.runOnImageLoad(function () {
                    macy.recalculate(true, true);
                    $(".project-gallery-grid__img-overlay").removeClass("not-loaded-yet");
                });
                addAndRecalculateHotspots();
                productLightbox.initInScope($body);
                filterSearch.initInScope($body);
                overlayToggle.initInScope($body);
            }
        });
    });
    $body.on("click", ".js-project-gallery-grid-quick-filter__item", function () {
        $(".js-product-grid__loading")[0].hidden = false;

        var keyword = $(this).find(".js-project-gallery-grid-quick-filter__text")[0].innerText;
        keyword = keyword.toLowerCase();
        const url = getUrlFromInput(keyword);

        history.pushState({
            'productGridAjaxUrl': url,
            'productGridInputState': [],
            'productGridAdditionalInputState': []
        },
            document.title,
            url
        );
        $.ajax({
            url: url,
            dataType: "json",
            success: (data) => {
                $(".js-product-grid__loading")[0].hidden = true;
                $(".pagenumber")[0].innerText = 0;
                const filterBar = $(".filter-bar__container")
                filterBar.empty();
                filterBar.append(data.filter);
                const galleryWrapper = $(".project-gallery-grid__gallery-wrapper")
                galleryWrapper.empty();
                galleryWrapper.append(data.html);
                macy.runOnImageLoad(function () {
                    macy.recalculate(true, true);
                    $(".project-gallery-grid__img-overlay").removeClass("not-loaded-yet")
                });
                addAndRecalculateHotspots();
                productLightbox.initInScope($body);
                filterSearch.initInScope($body);
                overlayToggle.initInScope($body);
            }
        });
    });
    $body.on("click", ".js-project-gallery-grid__remove-input", function () {
        $(".js-product-grid__loading")[0].hidden = false;
        const url = location.href.split("?")[0];
        history.pushState({
            'productGridAjaxUrl': url,
            'productGridInputState': [],
            'productGridAdditionalInputState': []
        },
            document.title,
            url
        );
        $.ajax({
            url: url,
            dataType: "json",
            success: (data) => {
                $(".js-product-grid__loading")[0].hidden = true;
                $(".pagenumber")[0].innerText = 0;
                const filterBar = $(".filter-bar__container")
                filterBar.empty();
                filterBar.append(data.filter);
                const galleryWrapper = $(".project-gallery-grid__gallery-wrapper")
                galleryWrapper.empty();
                galleryWrapper.append(data.html);
                macy.runOnImageLoad(function () {
                    macy.recalculate(true, true);
                    $(".project-gallery-grid__img-overlay").removeClass("not-loaded-yet")
                });
                addAndRecalculateHotspots();
                productLightbox.initInScope($body);
                filterSearch.initInScope($body);
                overlayToggle.initInScope($body);
            }
        });
    });
    $body.on("click", ".js-keep-open-dropdown-menu", function (event) {
        event.stopPropagation();
    });
    var processing = false
    $(document).scroll(function (e) {
        // grab the scroll amount and the window height
        var scrollAmount = $(window).scrollTop();
        var documentHeight = $(document).height();
        var windowHeight = $(window).height();
        var offset = 1200;

        if (scrollAmount >= documentHeight - windowHeight - offset && !processing) {
            load_more();
        }

        function load_more() {
            processing = true;
            const pageNumber = $(".pagenumber");
            if (pageNumber && pageNumber.length > 0) {
                pageNumber[0].innerText = parseInt(pageNumber[0].innerText) + 1;
                $.ajax({
                    url: location.href,
                    type: "POST",
                    dataType: "json",
                    data: {
                        "load_more": true,
                        "page": pageNumber[0].innerText
                    },
                    success: (data) => {
                        processing=false;
                        $(".project-gallery-grid__gallery-wrapper").append(data.html);
                        macy.runOnImageLoad(function (){
                            macy.recalculate(true, true);
                            $(".project-gallery-grid__img-overlay").removeClass("not-loaded-yet")
                        });
                        productLightbox.initInScope($body);
                        addAndRecalculateHotspots();
                    },
                    error: (data) => {
                        processing=false;
                    }
                });
            }
        }

    });

    $body.on("click", ".js-multiple-file-download__selected", function () {
        window.dataLayer = window.dataLayer || [];
        $(".js-multiple-file-download-select-container").find('.custom-checkbox__input:checked').each(function(){
            let name = $(this).attr('data-original-label');
            let filepath = $(this).attr('data-filepath');
            let filetype = filepath.slice(-3);
            window.dataLayer.push({
                event: 'downloadFile',
                'file_path': filepath,
                'file_type': filetype,
                'file_name': name
            });
        });
    });

    let oldName = $('.js_colorName').html();
    // let oldImage = $('.js_colorName').html()
    $('body .product-detail-main .js_colorPicker').on("mouseenter", function () {
        let newColor = $(this).find('input').val();
        let newColorName = $(this).find('img').attr('title');
        let newImage = $(document).find('.js_colorImage[data-colorimage="' + newColor + '"]')
        $(newImage).removeClass('hidden_for_others').addClass('show-color-image');
        $('.js_originalImage').addClass('hide_opacity');
        $('.js_colorName').html(newColorName);

    });
    $('body .product-detail-main .js_colorPicker').on("mouseleave", function () {
        $('.js_colorName').html(oldName);
        $('.js_colorImage').removeClass('show-color-image').addClass('hidden_for_others');
        $('.js_originalImage').removeClass('hide_opacity');
    });
    initModulesInScope();


    // Page Load Fix --> for more infos check out base.css and the loaded class
    $(document).ready(function () {
        $('body').addClass('loaded');
    });

    window.addEventListener("load", (event) => {
        if (window.location.href.includes('#') && window.scrollY == 0) {
            let href = window.location.href;
            let id = href.split(/[#?]/)[1];
            setTimeout(function () {
                document.querySelector('#' + id).scrollIntoView();
            }, 100);
        }
    });

    // Prevent form submissions and show popup message
    if ($(document).find('#maintenanceModal').length) {
        const showMaintenanceModal = function(e) {
            if ((e.type === 'submit' && $(e.target).find(':submit').hasClass('js__send-login')) || $(e.target).hasClass('product-detail-filter') || $(e.target).hasClass('navbar-search__form') || $(e.target).hasClass('js-multiple-file-download')) {
                return;
            }
            
            e.preventDefault();
            e.stopPropagation();
            
            const $modal = $('#maintenanceModal');

            $modal.modal('show');
            
            $modal.on('hidden.bs.modal', function() {
                $(this).modal('hide');
            });

            return false;
        };

        $('form').on('submit', showMaintenanceModal);
        $('.js_open-cart').on('click', showMaintenanceModal);
        $('form.js-cart__form').on('submit', showMaintenanceModal);
        $('.js-strex-summary__save').on('click', showMaintenanceModal);
    }
    // Country/Language Modal Handler
    const countryLanguageHandler = {
        countries: {
            'AUT': 'Austria',
            'BEL': 'Belgium',
            'BGR': 'Bulgaria',
            'DNK': 'Denmark',
            'DEU': 'Germany',
            'EST': 'Estonia',
            'FIN': 'Finland',
            'FRA': 'France',
            'GRC': 'Greece',
            'ITA': 'Italy',
            'ISL': 'Iceland',
            'HRV': 'Croatia',
            'LVA': 'Latvia',
            'LIE': 'Liechtenstein',
            'LTU': 'Lithuania',
            'LUX': 'Luxembourg',
            'MLT': 'Malta',
            'NLD': 'Netherlands',
            'NOR': 'Norway',
            'POL': 'Poland',
            'PRT': 'Portugal',
            'SWE': 'Sweden',
            'CHE': 'Switzerland',
            'SVK': 'Slovakia',
            'SVN': 'Slovenia',
            'ESP': 'Spain',
            'CZE': 'Czech Republic',
            'HUN': 'Hungary',
            'GBR': 'United Kingdom',
            'EUR': 'Rest of Europe', //show no prices
            'INT': 'International' // show no prices
        },

        languages: {
            'de': 'Deutsch',
            'en': 'English',
            'nl': 'Nederlands',
            'fr': 'Français',
            'es': 'Español',
            'it': 'Italiano'
        },

        restOfEurope: {
            'ALB': 'Albanien',
            'AND': 'Andorra',
            'ARM': 'Armenien',
            'AZE': 'Aserbaidschan',
            'BIH': 'Bosnien und Herzegowina',
            'BGR': 'Bulgarien',
            'GEO': 'Georgien',
            'IRL': 'Irland',
            'XKX': 'Kosovo',
            'MDA': 'Moldau',
            'MCO': 'Monaco',
            'MNE': 'Montenegro',
            'MKD': 'Nordmazedonien',
            'ROU': 'Rumänien',
            'SMR': 'San Marino',
            'SRB': 'Serbien',
            'TUR': 'Türkei',
            'UKR': 'Ukraine'
        },

        init() {
            this.modal = $('#countryLanguageModal');
            this.countryList = $('#countryList');
            this.languageList = $('#languageList');
            this.countryDropdownBtn = $('#countryDropdownBtn');
            this.languageDropdownBtn = $('#languageDropdownBtn');
            this.applyButton = $('.js-apply-selection');
            this.languageButton = $('.js_navbarLanguageButton');

            // Get saved selections from cookies
            // Populate dropdowns
            this.populateCountryList();
            this.populateLanguageList();

            const setCountryAndLanguageFromAPI = () => {
                $.ajax({
                    url: '/api/get-country-info',
                    method: 'GET',
                    success: (response) => {
                        if (response.success) {
                            const detectedCountry = response.data.detectedCountry;
                            const defaultLanguage = response.data.languages.default;

                            // Set cookies
                            document.cookie = `selected_country=${detectedCountry}; path=/`;
                            document.cookie = `selected_language=${defaultLanguage}; path=/`;

                            // Set initial selections
                            this.setSelectedCountry(detectedCountry);
                            this.setSelectedLanguage(defaultLanguage);

                            // Update language button with both country and language
                            this.updateLanguageButton(detectedCountry, defaultLanguage);
                        }
                    },
                    error: (xhr, status, error) => {
                        this.setSelectedCountry('INT');
                        this.setSelectedLanguage('EN');
                        this.updateLanguageButton('INT', 'EN');
                        this.modal.modal('show');
                        console.error('Error fetching country info:', error);
                    }
                });
            };

            // Check if cookies exist
            if (!this.getCookie('selected_country') || !this.getCookie('selected_language')) {
                setCountryAndLanguageFromAPI();
            } else {
                // Initialize with cookie values if they exist
                const storedCountry = this.getCookie('selected_country') || 'AUT';
                const storedLanguage = this.getCookie('selected_language') || 'DE';

                // Set initial selections
                this.setSelectedCountry(storedCountry);
                this.setSelectedLanguage(storedLanguage);

                // Update language button with both country and language
                this.updateLanguageButton(storedCountry, storedLanguage);

                // Only change URL if the current language doesn't match the stored language
                const currentLang = window.location.pathname.split('/')[1];
                if (currentLang !== storedLanguage.toLowerCase()) {
                    this.changeUrl(storedLanguage);
                }
            }
            this.bindEvents();
        },

        populateCountryList() {
            this.countryList.empty();
            Object.entries(this.countries).forEach(([code, name]) => {
                const li = $('<li></li>');
                const checkbox = this.createCheckbox(code, name, 'country');
                li.append(checkbox);
                this.countryList.append(li);
            });
        },

        populateLanguageList() {
            this.languageList.empty();
            Object.entries(this.languages).forEach(([code, name]) => {
                const li = $('<li></li>');
                const checkbox = this.createCheckbox(code, name, 'language');
                li.append(checkbox);
                this.languageList.append(li);
            });
        },

        createCheckbox(value, label, type) {
            return $(`
                <div class="custom-checkbox">
                    <label>
                        <input class="custom-checkbox__input js-${type}-select" 
                               type="radio" 
                               name="${type}" 
                               value="${value}" 
                               data-original-label="${label}">
                        <span class="custom-checkbox__box icon icon-check"></span>
                        <span class="custom-checkbox__active-box"></span>
                        <span class="custom-radio__text">
                            <span class="custom-radio__text__inner">
                                ${label}
                            </span>
                        </span>
                    </label>
                    <div class="form-errors"></div>
                </div>
            `);
        },

        setSelectedCountry(country) {
            this.countryList.find(`input[value="${country}"]`).prop('checked', true);
            const label = this.countries[country];
            this.countryDropdownBtn.html(`${label} <span class="icon icon-arrow-down dropdown-toggle__toggle" aria-label="open filter" style="position: absolute; right: 0;"></span>`);
            this.countryDropdownBtn.addClass('w-100 text-left');
        },

        setSelectedLanguage(language) {
            this.languageList.find(`input[value="${language.toLowerCase()}"]`).prop('checked', true);
            const label = this.languages[language.toLowerCase()];
            this.languageDropdownBtn.html(`${label} <span class="icon icon-arrow-down dropdown-toggle__toggle" aria-label="open filter" style="position: absolute; right: 0;"></span>`);
            this.languageDropdownBtn.addClass('w-100 text-left');
        },

        updateLanguageButton(country, language) {
            if (this.languageButton) {
                this.languageButton.text(`${country} | ${language.toUpperCase()}`);
            }
        },

        bindEvents() {
            // Handle language button click to open modal
            if (this.languageButton) {
                this.languageButton.on('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.modal.modal('show');
                });
            }

            // Handle country selection
            this.countryList.on('change', 'input[type="radio"]', (e) => {
                const selected = $(e.target);
                const value = selected.val();
                const label = selected.data('original-label');
                this.countryDropdownBtn.html(`${label} <span class="icon icon-arrow-down dropdown-toggle__toggle" aria-label="open filter" style="position: absolute; right: 0;"></span>`);
                this.countryDropdownBtn.addClass('w-100 text-left');
                // Close the country dropdown
                $('.dropdown-menu--country').removeClass('show');
                // Hide the dropdown using Bootstrap's dropdown method
                $(e.target).closest('.dropdown').find('.dropdown-toggle').dropdown('hide');
            });

            // Handle language selection
            this.languageList.on('change', 'input[type="radio"]', (e) => {
                const selected = $(e.target);
                const value = selected.val();
                const label = selected.data('original-label');
                this.languageDropdownBtn.html(`${label} <span class="icon icon-arrow-down dropdown-toggle__toggle" aria-label="open filter" style="position: absolute; right: 0;"></span>`);
                this.languageDropdownBtn.addClass('w-100 text-left');
                // Close the language dropdown
                $('.dropdown-menu--language').removeClass('show');
                // Hide the dropdown using Bootstrap's dropdown method
                $(e.target).closest('.dropdown').find('.dropdown-toggle').dropdown('hide');
            });

            // Handle apply button click
            this.applyButton.on('click', () => {
                const country = this.countryList.find('input:checked').val();
                const language = this.languageList.find('input:checked').val();

                if (!country || !language) {
                    return; // Don't proceed if either selection is missing
                }

                // Save selections to cookies
                this.setCookie('selected_country', country, 365);
                this.setCookie('selected_language', language, 365);

                // Update language button with both country and language
                this.updateLanguageButton(country, language);

                const languageLinks = window._config.languageLinks || {};
                const targetUrl = languageLinks[language.toUpperCase()];
                if (targetUrl) {
                    window.location.href = targetUrl;
                }

                // Close the modal
                this.modal.modal('hide');
            });
        },
        changeUrl(language) {
            const languageLinks = window._config.languageLinks || {};
            const targetUrl = languageLinks[language.toUpperCase()];

            if (targetUrl) {
                // Get the current URL without query parameters
                const currentUrl = window.location.pathname;
                // Get the target URL without query parameters (in case it's a full URL)
                const targetPath = targetUrl.split('?')[0];

                // Only redirect if the current URL is different from the target URL
                if (currentUrl !== targetPath) {
                    window.location.href = targetUrl;
                }
            }
        },

        setCookie(name, value, days) {
            const d = new Date();
            d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
            const expires = "expires=" + d.toUTCString();
            document.cookie = name + "=" + value + ";" + expires + ";path=/";
        },

        getCookie(name) {
            const nameEQ = name + "=";
            const ca = document.cookie.split(';');
            for(let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(nameEQ) === 0) {
                    return c.substring(nameEQ.length, c.length);
                }
            }
            return null;
        }
    };

    // Initialize the country/language handler when document is ready
    // also initialize the external price handler
    $(document).ready(() => {

        if($('#countryLanguageModal').length > 0) {
            countryLanguageHandler.init();
        }
        fetchBulkPrices();
    });
    $('body').on('product-grid.success', function () {
        fetchBulkPrices();
    });

    // Close open menu items when clicking on a link
    document.addEventListener(
        'click',
        (e) => {
            const a = e.target.closest('nav a');
            if (a) {
                e.stopImmediatePropagation();
                document
                    .querySelectorAll('nav .is-open')
                    .forEach((el) => el.classList.remove('is-open'));
            }
        },
        true
    );
})($);


